/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of reward attached to a prize draw.
 */
export type DrawRewardTypeEnum =
  (typeof DrawRewardTypeEnum)[keyof typeof DrawRewardTypeEnum]

export const DrawRewardTypeEnum = {
  YEAR_OF_ENERGY: "YEAR_OF_ENERGY",
  ACCOUNT_CREDIT_10_POUNDS: "ACCOUNT_CREDIT_10_POUNDS",
  ACCOUNT_CREDIT_20_POUNDS: "ACCOUNT_CREDIT_20_POUNDS",
  ACCOUNT_CREDIT: "ACCOUNT_CREDIT",
  YEAR_OF_ENERGY_LEGACY: "YEAR_OF_ENERGY_LEGACY",
  EV_CHARGER: "EV_CHARGER",
  EV_CHARGER_CREDIT: "EV_CHARGER_CREDIT",
  HOMETREE: "HOMETREE",
  VOUCHER: "VOUCHER",
} as const
